var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "location_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#location_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 11.75c.486 0 .899-.17 1.24-.51.34-.341.51-.754.51-1.24s-.17-.9-.51-1.24c-.341-.34-.754-.51-1.24-.51s-.9.17-1.24.51c-.34.34-.51.754-.51 1.24s.17.899.51 1.24c.34.34.754.51 1.24.51zm0 8.052c2.059-1.841 3.615-3.598 4.67-5.27 1.053-1.673 1.58-3.117 1.58-4.332 0-1.894-.603-3.442-1.81-4.645C15.234 4.352 13.754 3.75 12 3.75c-1.754 0-3.234.602-4.44 1.805C6.353 6.758 5.75 8.306 5.75 10.2c0 1.215.527 2.66 1.58 4.332 1.055 1.672 2.611 3.429 4.67 5.27zm0 1.66a1.047 1.047 0 01-.664-.237c-2.382-2.144-4.158-4.133-5.33-5.968C4.837 13.42 4.25 11.736 4.25 10.2c0-2.423.78-4.354 2.34-5.792C8.15 2.969 9.954 2.25 12 2.25c2.046 0 3.85.72 5.41 2.158s2.34 3.369 2.34 5.792c0 1.536-.586 3.221-1.757 5.057-1.17 1.835-2.947 3.824-5.33 5.968a.902.902 0 01-.306.176c-.118.04-.236.06-.357.06z",
    fill: "#12385C"
  }))));
}
export default SvgLocation;